/* jshint camelcase:false */
/**
 * Traveler Checkout Config settings to read/write settings values used for checkout specific config
 */

import constants from './constants';

const config = {
    selectedPaymentType: constants.paymentTypes.PLATFORM,
    numberOfPaymentRequests: 1,

    setInitalSelectedPaymentType(checkoutModel) {
        if (checkoutModel.hasOnlinePaymentMethodsEnabled()) {
            this.selectedPaymentType = constants.paymentTypes.PLATFORM;
        } else if (checkoutModel.hasOfflinePaymentMethodsEnabled()) {
            this.selectedPaymentType = constants.paymentTypes.OFFLINE;
        }
    },

    setNumberOfPaymentRequests(numberOfPaymentRequests) {
        this.numberOfPaymentRequests = numberOfPaymentRequests;
    },
};

export default config;
